import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

interface Props {
  children: JSX.Element;
}

export const PublicRoute = ({ children }: Props) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (isAuthenticated) {
    if (user && user.privacyAccepted === false && location.pathname !== '/privacy-policy') {
      return <Navigate to="/privacy-policy" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};
